import { HomeData } from '../../types';

const homeData: HomeData = {
  welcome: "Hi",
  name: "I'm Robin",
  skills: [
    "Product Builder",
    "AI-Native Developer",
    "App Developer",
    "Fullstack Dev",
    "DevOps Engineer",
    "Performance Optimizer",
    "Accessibility Expert",
    "UI Designer",
    "Prompt Engineer",
    "Agentic-Cluster-Orchestrator",
    "Game Console Hacker",
    "3D Printer Whisperer",
    "Media Designer",
    "Sourdough Pro",
    "Nerd",
  ],
  intro: "As a passionate frontend developer with over {yearsExp} years of experience, I create elegant, user-friendly websites and applications that are both technically solid and aesthetically pleasing.",
  buttons: {
    work: "My Work",
    contact: "Get in Touch"
  },
  features: [
    {
      title: "Frontend Expertise",
      desc: "Modern frameworks like React, Next.js and Flutter, combined with a strong focus on performance, usability, Web Vitals and accessibility.",
      iconName: "frontend"
    },
    {
      title: "Responsive Design",
      desc: "Flawless rendering on every device, from desktop to smartphone, with interfaces optimized for each screen size.",
      iconName: "responsive"
    },
    {
      title: "Web Standards",
      desc: "Clean, accessible code built to current standards, ensuring browser compatibility and long-term maintainability.",
      iconName: "standards"
    },
    {
      title: "Docker & Engineering",
      desc: "Experience containerizing applications with Docker to create consistent development and production environments.",
      iconName: "docker"
    },
    {
      title: "Cloud Services",
      desc: "Experience with Cloudflare, Firebase and Google Cloud for building scalable, high-performance applications.",
      iconName: "cloud"
    },
    {
      title: "GitHub CI/CD",
      desc: "Automating the entire development workflow with GitHub CI/CD for fast, reliable deployments.",
      iconName: "automation"
    },
    {
      title: "App Development",
      desc: "Building cross-platform applications with Flutter that run on iOS / Android and macOS. Deployed to the App Store and Google Play.",
      iconName: "app-development"
    },
  ],
  brands: {
    title: "Companies and brands I've worked with",
    groups: [
      ["Allianz", "Daimler AG", "Deutsche Post", "Deutsche Telekom", "Lufthansa", "Volkswagen", "Montblanc", "Mercedes", "Netflix"],
      ["Dr. Oetker", "SEAT", "Storck", "Gerolsteiner", "Migros", "Swatch", "Unilever", "Red Bull", "IKEA", "DPD"],
      ["Hubert Burda", "Osram", "Peta", "Imperial Tobacco", "Dräger", "Palmers", "Tesa", "Deutscher Ring", "Gruner + Jahr", "Tchibo"],
      ["Coca-Cola", "TV-Today", "Otto", "Swarovski", "Yogi Tea", "EnBW", "apo.com Group", "Burger King", "TV-Spielfilm", "Fit for Fun", "FRoSTA", "Hapag Lloyd", "Studioline"]
    ]
  },
  experience: {
    number: "{formattedYears}",
    label: "years of experience",
    text: "From table layouts to an AI-native workflow. Everything in between lives over at Work."
  },
  cta: {
    title: "Interested in working together?",
    desc: "Let's talk about your next project and how I can help you take your digital presence to the next level.",
    button: "Get in Touch"
  }
};

export default homeData;
